import { Alert, Button, ButtonProps, Text } from "@fluentui/react-northstar";
import { TeamsSubscriptionPlans } from "@teams/types";
import React, { useState } from "react";

type Props = {
  primaryColor: string;
  trialLength: number;
  plan: TeamsSubscriptionPlans;
  onTrialRequested: (plan: TeamsSubscriptionPlans) => Promise<string | undefined>;
} & ButtonProps;

export const TrialRequestButton: React.FC<Props> = ({
  primaryColor,
  trialLength,
  plan,
  onTrialRequested,
  ...buttonProps
}) => {
  const [isLoading, setIsLoading] = useState<boolean>();
  const [trialError, setTrialError] = useState<string>();

  return (
    <>
      <Button
        className="plan-item__plan-select-button"
        variables={{
          height: 40,
          backgroundColor: primaryColor,
          color: "white",
        }}
        styles={{
          marginBottom: ".5rem",
        }}
        content={<Text content={`Start ${trialLength}-Day Free Trial!`} size="large" />}
        fluid
        loading={isLoading}
        disabled={isLoading}
        onClick={async () => {
          setTrialError(undefined);
          setIsLoading(true);
          const result = await onTrialRequested(plan);
          setIsLoading(false);

          if (result) {
            setTrialError(result);
          }
        }}
        {...buttonProps}
      />
      {trialError && <Alert attached="bottom" content={trialError} danger />}
    </>
  );
};
